import {
  createBrowserRouter,
  Navigate,
  type RouteObject,
} from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { OdkazDoAppky, OtvorOdkaz } from "@/components/layout/OdkazDoAppky";
import { LoginPage } from "@/pages/LoginPage";
import { ZakazkyListPage } from "@/pages/ZakazkyListPage";
import { ZakazkaEditorPage } from "@/pages/ZakazkaEditorPage";
import { KovaniaPage } from "@/pages/KovaniaPage";
import { CennikPage } from "@/pages/CennikPage";
import { NastaveniaPage } from "@/pages/NastaveniaPage";
import { HistoriaPage } from "@/pages/HistoriaPage";
import { ObjednavkyPage } from "@/pages/ObjednavkyPage";
import { SpravaPage } from "@/pages/SpravaPage";

/**
 * Router pre Tandem Rozpočet R1.
 * - `/login` — prihlásenie (bez AppShell layoutu)
 * - `/` redirect → `/zakazky`
 * - `/zakazky` (C11) — prehľad zákaziek
 * - `/zakazky/:id` (C12) — editor s tripartit layout-om
 * - `/cennik` (C13) — browser cenníka materiálov
 * - `/objednavky` — čo treba na zákazky kúpiť a kto to už objednal
 * - `/historia` — audit log: kto, kedy a čo zmenil
 * - `/sprava` — odpracovaný čas + účty (admin)
 * - `/nastavenia` — placeholder pre R2
 * - `/otvor` — appka spustená odkazom `web+rozpocet:` (KOLO 215)
 *
 * Všetky routes okrem /login sú za RequireAuth gate-om (pri vypnutej
 * auth prepúšťa všetko — pôvodné správanie).
 *
 * `/daex` a `/import` (KOLO 69) sú zrušené; catch-all ich aj s hocijakou
 * inou neznámou cestou hodí na zoznam zákaziek, aby kolega s bookmarkom
 * nedostal prázdny AppShell.
 */
/** Route strom — vytknutý kvôli testu, ktorý stráži zrušené cesty. */
export const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    // Odkaz z Tandem Zostáv v karte prehliadača odovzdá appke (KOLO 215)
    element: (
      <OdkazDoAppky>
        <RequireAuth>
          <AppShell />
        </RequireAuth>
      </OdkazDoAppky>
    ),
    children: [
      { index: true, element: <Navigate to="/zakazky" replace /> },
      // Spustenie appky protokolom web+rozpocet (manifest, KOLO 215)
      { path: "otvor", element: <OtvorOdkaz /> },
      { path: "zakazky", element: <ZakazkyListPage /> },
      { path: "zakazky/:id", element: <ZakazkaEditorPage /> },
      { path: "cennik", element: <CennikPage /> },
      { path: "kovania", element: <KovaniaPage /> },
      { path: "objednavky", element: <ObjednavkyPage /> },
      { path: "historia", element: <HistoriaPage /> },
      { path: "sprava", element: <SpravaPage /> },
      { path: "nastavenia", element: <NastaveniaPage /> },
      { path: "*", element: <Navigate to="/zakazky" replace /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
